import React, { ErrorInfo } from 'react';
import ErrorFallBackComponent from './ErrorfallBackComponent';

type Props = {
    children: React.ReactNode,
};

type State = {
    hasError: boolean,
    error?: Error,
};

class ErrorHandlerComponent extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            hasError: false,
        };
    }

    componentDidCatch(error: Error, errorInfo : ErrorInfo): void {
        // Log the error to an error reporting service
        console.error(error, errorInfo);
    }

    static getDerivedStateFromError(error: Error) {
        console.error(error);
        // Update state so the next render will show the fallback UI.
        return { hasError: true, error };
    }

    render() {
        const { children } = this.props;
        const { error, hasError } = this.state;
        return (
            hasError && error ? (
                <ErrorFallBackComponent error={error} />
            ) : (children)
        );
    }
}

export default ErrorHandlerComponent;
